let config = {
    sdk: 'NIM_Web_SDK_v6.1.0',
    webRTC: 'NIM_Web_WebRTC_v6.1.0',
    // 用户自定义的登录注册地址
    loginUrl: '/#/login',
    // registUrl: '/webdemo/h5/regist.html',
    // homeUrl: '/webdemo/h5/index.html#/session',

    pageMap:window.ServerConfig.pageMap,

    // 资源路径根目录，为了方便用户部署在二级以上URL路径上
    resourceUrl: 'http://yx-web.nos.netease.com/webdoc/h5',
    // 用户logo地址
    logo: 'http://yx-web.nos.netease.com/webdoc/h5/im/logo.png',
    // 默认用户头像
    defaultUserIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-icon.png',
    // 默认普通群头像
    defaultGroupIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-group.png',
    // 默认高级群头像
    defaultAdvancedIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-advanced.png',
    // 系统通知图标
    noticeIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/notice-icon.png',
    // 我的手机图标
    myPhoneIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/my-phone.png',
    // 本地消息显示数量，会影响性能
    localMsglimit: 36,
    useDb: false
};

const env = 'online';

let appConfig = {
    // 用户的appkey14cf25fda9b62fd63a1640aed311583e  、b00dac6f7d1df13bb7afc6200d65abd9
    // 用于在web demo中注册账号异步请求demo 服务器中使9b05bf45fdb49638a94d6b52653a96c5用45c6af3c98409b18a84451215d0bdd6e
    test: {
        appkey: '9b05bf45fdb49638a94d6b52653a96c5',
        postUrl: 'https://apptest.netease.im'
    },
    online: {
        appkey: '9b05bf45fdb49638a94d6b52653a96c5',
        postUrl: 'https://app.netease.im'
    }
};

config = Object.assign(config, appConfig[env]);

export default config



// WEBPACK FOOTER //
// ./src/config/index.js